export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const categories: Category[] = [
  { id: "rejie", name: "热血冒险", icon: "ri-flashlight-fill", desc: "燃向战斗与冒险" },
  { id: "xianxia", name: "奇幻仙侠", icon: "ri-sparkling-fill", desc: "仙途剑侠与修真" },
  { id: "dushi", name: "都市生活", icon: "ri-building-fill", desc: "都市职场与世情" },
  { id: "xiaoyuan", name: "校园青春", icon: "ri-graduation-cap-fill", desc: "校园与青春成长" },
  { id: "xuanyi", name: "悬疑推理", icon: "ri-search-eye-fill", desc: "谜团与烧脑案件" },
  { id: "lianai", name: "恋爱治愈", icon: "ri-heart-fill", desc: "温暖与心动日常" },
  { id: "kehuan", name: "科幻末世", icon: "ri-rocket-fill", desc: "星际与废土世界" },
];

export const hotTags: string[] = [
  "本周爆更",
  "热门连载",
  "新作推荐",
  "完结佳作",
  "高能剧情",
  "爽文改编",
];